/**
 * Oversea 站点 SEO 配置：hreflang、canonical、多语言/多地区
 * 用于搜索引擎正确展示语言与地区版本
 */

/** 站点根 URL，与 sitemap 一致，可按环境覆盖 */
export const OVERSEA_SITE_BASE_URL = typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_SITE_URL
  ? process.env.NEXT_PUBLIC_SITE_URL.replace(/\/$/, '')
  : 'https://www.roboneo.com';

/** 海外首页路径 */
export const OVERSEA_HOME_PATH = '/';

/** 国内首页路径（网关重定向后入口，如 pre.roboneo.com/home），用于 hreflang 互指 */
export const DOMESTIC_HOME_PATH = '/home';

/**
 * hreflang 配置：语言/地区 -> 对应绝对 URL
 * - en: 海外英文版（当前页）
 * - x-default: 未匹配时的默认页（通常为国际英文）
 * - zh-CN: 国内中文版（网关重定向入口 /home）
 */
export const HREFLANG_ALTERNATES: { hreflang: string; href: string; }[] = [
  { hreflang: 'en', href: `${OVERSEA_SITE_BASE_URL}${OVERSEA_HOME_PATH}` },
  { hreflang: 'x-default', href: `${OVERSEA_SITE_BASE_URL}${OVERSEA_HOME_PATH}` },
  { hreflang: 'zh-CN', href: `${OVERSEA_SITE_BASE_URL}${DOMESTIC_HOME_PATH}` },
];

/** 海外首页 canonical URL */
export const OVERSEA_CANONICAL_URL = `${OVERSEA_SITE_BASE_URL}${OVERSEA_HOME_PATH}`;

/** 海外首页标题，必须在服务端 HTML 中稳定输出，避免依赖客户端初始化。 */
export const OVERSEA_HOME_TITLE = 'RoboNeo | AI-Powered Video Generator for Stories & Social Content';

/** 海外首页摘要，供搜索结果和社交分享卡片使用。 */
export const OVERSEA_HOME_DESCRIPTION = 'Create, edit, and enhance AI videos with RoboNeo. From script generation to consistent video creation and batch production in one workflow.';

/** 海外首页关键词。 */
export const OVERSEA_HOME_KEYWORDS = 'AI video agent, social media AI creation, trend video templates, agent video workflow, viral video generation, creator growth tools';
